/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';

import PropTypes from 'prop-types';

// COMPONENT
import Alert from '../../components/Alert/Alert';

import styles from './Alerts.module.scss';

// ASSETS
const notificationIcon = require('./imgs/icon.png');

class Alerts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showNotification: false,
    };
  }

  render() {
    const { showNotification } = this.state;
    const { toggleAlerts } = this.props;
    return (
      <div className={styles.alertsWrapper}>
        <div
          onClick={() => this.setState({ showNotification: false })}
          className={[
            styles.notificationWrapper,
            showNotification ? styles.showNotification : null,
          ].join(' ')}
        >
          <div className={styles.notificationContainer}>
            <div className={styles.header}>
              <div>
                <div>
                  <img alt="notification" src={notificationIcon} />
                </div>
                <p>MARKET SHARE</p>
              </div>
              <span>now</span>
            </div>
            <p>Kimberly Clark Share has dropped 9%</p>
            <p>
              Sed posuere consectetur est at lobortis. Donec
              ullamcorper nulla non metus auctor.
            </p>
          </div>
        </div>
        <div className={styles.alertsContainer}>
          {/* NAVIGATION HEADER */}
          <div className={styles.alertsHeader}>
            <p onClick={toggleAlerts}>&lt;Back</p>
          </div>
          {/* BODY HEADER */}
          <div className={styles.alertsHero}>
            <div>
              <div />
              <p>My Alerts</p>
            </div>
            <button
              onClick={() => this.setState({ showNotification: true })}
              type="button"
            >
              + Create New Alert
            </button>
          </div>
          <Alert id={1} />
          <Alert id={2} />
        </div>
      </div>
    );
  }
}

Alerts.propTypes = {
  toggleAlerts: PropTypes.func.isRequired,
};

export default Alerts;
